import { Col, Row } from "react-bootstrap";
import "@js-joda/timezone";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { AlertType, useAlertEmit } from "../common/alert/Alert";
import { Button } from "../components/Button";
import { Card } from "../components/Card";

export const TabDemoSettings = () => {
	const emit = useAlertEmit();
	const queryClient = useQueryClient();

	const handleDelete = useMutation({
		mutationFn: async () => {
			await axios.post("/api/company/recreate");
			await queryClient.refetchQueries();
		},
		onSuccess: async () => {
			emit({
				type: AlertType.SUCCESS,
				content: "Company data has been cleaned",
			});
		},
		onError: () => {
			emit({
				type: AlertType.ERROR,
				content: "Something went wrong",
			});
		},
	});

	return (
		<>
			<h2 className="mb-4">Demo Settings</h2>
			<Row>
				<Col md={4}>
					<Card>
						<Card.Header>Delete company data and posts</Card.Header>
						<Card.Body>
							Delete all company information data, marketing plans and posts.
							This action is irreversible.
							<div className="mt-5">
								<Button
									variant="danger"
									icon="delete"
									onClick={() => handleDelete.mutateAsync()}
								>
									Delete
								</Button>
							</div>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
};
